<script>
    import { mapState, mapActions, mapMutations } from 'vuex';

    export default {

        computed: {
            ...mapState({
                $_me: state => state.me.user,
            }),
        },

        methods: {
            ...mapMutations('jobApplication', {
                $_STORE_APPLY_AS_GUEST_USER: 'STORE_APPLY_AS_GUEST_USER',
                $_STORE_APPLY_AS_EXISTING_USER: 'STORE_APPLY_AS_EXISTING_USER',
                $_STORE_APPLY_USER: 'STORE_USER',
            }),

            ...mapMutations('me', {
                $_STORE_GUEST_RESUME: 'STORE_GUEST_RESUME',
            }),

            ...mapActions('me', {
                $_checkUserEmail: 'checkEmail',
                $_storeAllUserData: 'storeAllUserData',
                $_createGuestResume: 'createGuestResume',
            }),

            ...mapActions('auth', {
                $_authRegister: 'register',
            }),

            ...mapActions('jobApplication', {
                $_applyToJob: 'applyToJob',
            }),    
        },
    };
</script>
